import { ISelectData } from 'components/atoms/SelectComponent';

export const leiCountrySelect: ISelectData[] = [
    {
        value: 'CZ',
        labelcz: 'Česko',
        labelen: 'Czechia'
    },
    {
        value: 'SK',
        labelcz: 'Slovensko',
        labelen: 'Slovakia'
    },
    {
        value: 'EE',
        labelcz: 'Estonsko',
        labelen: 'Estonia'
    },
    {
        value: 'HR',
        labelcz: 'Chorvatsko',
        labelen: 'Croatia'
    },
    {
        value: 'IE',
        labelcz: 'Irsko',
        labelen: 'Ireland'
    },
    {
        value: 'LV',
        labelcz: 'Lotyšsko',
        labelen: 'Latvia'
    },
    {
        value: 'LU',
        labelcz: 'Lucembursko',
        labelen: 'Luxembourg'
    },
    {
        value: 'CY',
        labelcz: 'Kypr',
        labelen: 'Cyprus'
    },
    {
        value: 'HU',
        labelcz: 'Maďarsko',
        labelen: 'Hungary'
    },
    {
        value: 'MT',
        labelcz: 'Malta',
        labelen: 'Malta'
    },
    {
        value: 'DE',
        labelcz: 'Německo',
        labelen: 'Germany'
    },
    {
        value: 'NL',
        labelcz: 'Nizozemsko',
        labelen: 'Netherlands (the)'
    },
    {
        value: 'PL',
        labelcz: 'Polsko',
        labelen: 'Poland'
    },
    {
        value: 'AT',
        labelcz: 'Rakousko',
        labelen: 'Austria'
    },
    {
        value: 'RO',
        labelcz: 'Rumunsko',
        labelen: 'Romania'
    },
    {
        value: 'SI',
        labelcz: 'Slovinsko',
        labelen: 'Slovenia'
    },
    {
        value: 'GB',
        labelcz: 'Velká Británie',
        labelen: 'United Kingdom of Great Britain and Northern Ireland (the)'
    },
    {
        value: 'SE',
        labelcz: 'Švédsko',
        labelen: 'Sweden'
    },
    {
        value: 'CH',
        labelcz: 'Švýcarsko',
        labelen: 'Switzerland'
    }
];

export const leiCountrySelectFondy: ISelectData[] = [
    {
        value: 'CZ',
        labelcz: 'Česko',
        labelen: 'Czechia'
    },
    {
        value: 'SK',
        labelcz: 'Slovensko',
        labelen: 'Slovakia'
    },
    {
        value: 'MT',
        labelcz: 'Malta',
        labelen: 'Malta'
    },
    {
        value: 'IE',
        labelcz: 'Irsko',
        labelen: 'Ireland'
    }
];

export const leiCountrySelectInternational: ISelectData[] = [
    {
        value: 'EU',
        labelcz: 'EU',
        labelen: 'EU'
    },
    {
        value: 'UN',
        labelcz: 'UN',
        labelen: 'UN'
    },
    {
        value: 'XX',
        labelcz: 'XX',
        labelen: 'XX'
    }
];
